import Vue from 'vue'
import Router from 'vue-router'
import signin from './views/SignIn.vue';
import signup from './views/SignUp.vue';
import createprofile from './views/CreateProfile.vue';
import forgotpassword from './views/ForgotPassword.vue';
import LandingPage from './views/LandingPage/LandingPageUpdated.vue';
// import LandingPage from './views/LandingPage/LandingPageNew.vue';
import PostedJobs from './views/PostedJobs.vue'
import Welcome from './views/WelcomePage.vue';
import EditJob from './views/WelcomePage.vue'
import ViewJob from './views/viewJob/ViewJobDetails.vue'
import ViewCandidate from './views/viewJob/CandidateDetails.vue'
import SavedJobs from './views/SavedJobs.vue'
import ClosedJobs from './views/ClosedJobs.vue'
import DraftJobs from './views/DraftJobs.vue'
import CreatedJobs from './views/deletedJob/CreatedJob.vue'
import ReportIssue from './views/ReportIssue.vue'
//find resumes
import FindResumes from './views/viewJob/FindUserResumes.vue'
import ViewResume from './views/viewJob/UserResumeData.vue'
import Test from './views/test.vue'
import TermsandConditions from './views/TermsandConditions.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
//check
import MainComponent from './components/MainComponent.vue'
import store from './store.js'
import sessionUtils from "@/js/session-util.js";
Vue.use(Router)

let router = new Router({
  mode : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    }, 
    {
      path : '/',
      name : 'maincomponent',
      component : MainComponent,
      children: [
        {
          path: '/createprofile',
          name: 'createprofile',
          component: createprofile
        },
        {
          path: '/editprofile',
          name: 'editprofile',
          component: createprofile
        },
        {
          path: '/postedjobs',
          name: 'postedJobs',
          component: PostedJobs
        },
        {
          path: '/savedjobs',
          name: 'savedJobs',
          component: SavedJobs
        },
        {
          path: '/deletedjobs',
          name: 'createdJobs',
          component: CreatedJobs
        },
        {
          path: '/draftjobs',
          name: 'draftJobs',
          component: DraftJobs
        },
        {
          path: '/closedjobs',
          name: 'closedJobs',
          component: ClosedJobs
        },
        {
          path: '/postajob',
          name: 'postajob',
          component: Welcome
        },
        {
          path: '/editjob',
          name: 'editjob',
          component: EditJob
        },
        {
          path: '/viewjob/:id',
          name: 'viewjob',
          component: ViewJob
        },
        {
          path: '/findresumes',
          name: 'findResumes',
          component: FindResumes
        },
        {
          path : '/user-resume-details',
          name : 'userresume_details',
          component : ViewResume
        },
        {
          path : '/requested-resume',
          name : 'requested_resume_details',
          component : ViewResume
        },
        {
          path : '/candidate-details',
          name : 'candidate_details',
          component : ViewCandidate
        },
        {
          path: '/reportissue',
          name: 'reportissue',
          component : ReportIssue
        }
      ]        
    },
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/forgot',
      name: 'forgotpassword',
      component: forgotpassword
    },
    {
      path:'/termsandconditions',
      name : 'termsandconditions',
      component : TermsandConditions
    },
    {
      path:'/privacypolicy',
      name : 'privacypolicy',
      component : PrivacyPolicy
    }
    // {
    //   path : '/test',
    //   name : 'test',
    //   component : Test
    // }
    
]
})
router.beforeEach((to, from, next) => {
  var isLoggedin = localStorage.getItem('isLoggedin')
  var userId = localStorage.getItem('business_account_id')
  var userprofileID = localStorage.getItem('company_profile_id')
  if(to.name === 'viewjob'){
    const session = Vue.prototype.$session;
    sessionUtils.setSelectedJobId(to.params.id)
  }
  if(to.path != '/signin' && to.path != '/test' && to.path != '/' && to.path != '/signup' && to.path != '/forgot' && to.path != '/termsandconditions' && to.path != '/privacypolicy' && to.path != '/how-worknotion-works') {
      if(isLoggedin === "true" && userId) { 
          console.log('User already logged in', isLoggedin);
          next();
      } else {
          console.log("User didn't logged in", isLoggedin);
          next('signin');
      }
  } else {
    if(isLoggedin === "true" && userId && to.path != '/termsandconditions' && to.path != '/privacypolicy'){
      if(userprofileID){
        next('postedJobs')
      }else{
        next()
      }
    }else{
    next();
    }
  }
});
router.afterEach((to, from) => {
  store.state.routeName = to.name;
})
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}
export default router;